// this is an autogenerated file from App/Account/Content/Settings/Content/Onboarding/TxCardFields/mutation.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Settings_Content_Onboarding_TxCardFields($location_ids: [uuid!]!) {
  result: onboarding_inputs_tx_card_fields(location_ids: $location_ids) {
    ok
  }
}

`